<div id="mailDescriptionPanel" [ngClass]="{ reduced: hideMailInfo, expanded: !hideMailInfo }" *ngIf="currentEmail">
  <!-- <div title="{{ 'agent:contact.workspace.mail.history.close_email_history_erea' | translate }}">
    <button class="cng-ico_close closeOnly" (click)="hideBlock(); _expandZoneResponse()">
      <span class="nodisplay">{{ 'agent:contact.workspace.mail.history.close_email_history_erea' | translate }}</span>
    </button>
  </div> -->
  <ul>
    <li title="{{ 'agent:contact.workspace.mail.history.mail_content' | translate }}">
      <button class="cng-ico_mail" [ngClass]="{ current: currentDescriptionToshow }" (click)="showPannel('emailcontent')">
        <span class="nodisplay">{{ 'agent:contact.workspace.mail.history.mail_content' | translate }}</span>
      </button>
    </li>
    <li title="{{ 'agent:contact.workspace.mail.history.mail_information' | translate }}">
      <button class="cng-ico_info" [ngClass]="{ current: currentInfoToshow }" (click)="showPannel('emailinfo')">
        <span class="nodisplay">{{ 'agent:contact.workspace.mail.history.mail_information' | translate }}</span>
      </button>
    </li>
    <li
      title="{{ 'agent:contact.workspace.mail.history.mail_attachment' | translate }}"
      *ngIf="!!currentEmail.allAttachment && currentEmail.allAttachment.length > 0"
    >
      <button
        *ngIf="currentEmail.allAttachment.length < 2"
        class="cng-ico_attach attachment_panel-btn"
        [ngClass]="{ current: currentAttachmentToshow }"
        [attr.aria-label]="'agent:contact.workspace.mail.history.mail_attachment' | translate"
        (click)="showPannel('emailattachment')"
      ></button>
      <button
        *ngIf="currentEmail.allAttachment.length >= 2"
        class="cng-ico_attach attachment_panel-btn"
        [ngClass]="{ current: currentAttachmentToshow }"
        [attr.aria-label]="
          'agent:contact.workspace.mail.history.mail_attachments' | translate: { number: currentEmail.allAttachment.length }
        "
        (click)="showPannel('emailattachment')"
      ></button>
    </li>
  </ul>
  <data *ngIf="mailPanelToshow === 'emailcontent'">
    <history-mail-panel-content [currentEmail]="currentEmail" [requestPromise]="requestPromise"></history-mail-panel-content>
  </data>
  <data *ngIf="mailPanelToshow === 'emailinfo'">
    <history-mail-panel-info
      [currentMailSender]="currentEmail.evt.sender"
      [currentMailRecipient]="currentEmail.evt.recipient"
      [currentMailccRecipient]="currentEmail.evt.ccRecipient"
      [currentMailBccRecipient]="currentEmail.evt.bccRecipient"
      [currentMailSubject]="currentEmail.evt.subject"
      [currentMailResquetId]="currentEmail.evt.requestId"
    >
    </history-mail-panel-info>
  </data>
  <data *ngIf="mailPanelToshow === 'emailattachment'">
    <history-mail-panel-attachment [currentEmail]="currentEmail"></history-mail-panel-attachment>
  </data>
</div>
<div id="mailThreadBar">
  <button class="button_mail_history cng-ico_mail">
    {{ historyLength() }}
  </button>
  <div title="{{ 'agent:contact.workspace.mail.history.display_previous_mail' | translate }}">
    <button
      class="arrow left"
      [attr.aria-label]="'agent:contact.workspace.mail.history.display_previous_mail' | translate"
      (click)="indicatorsSlider_prev()"
      [disabled]="resultLeft"
    >
      <span class="nodisplay">{{ 'agent:contact.workspace.mail.history.display_previous_mail' | translate }}</span>
    </button>
  </div>

  <ul id="MailHistoryList" #mailHistoryList>
    <li
      [ngClass]="{ current: checkIsCurrentMail(i, indexCurrentMailOpen) }"
      [ngStyle]="{ 'min-width': tabData?.minSize, width: tabData?.actualSize }"
      *ngFor="let data of blockToDisplayinternalEvents; let i = index"
    >
      <button
        class="mail-history"
        title="{{ getHeaderDate(data.evt) + '&#10;' + extractNameSender(data.evt) }}"
        (click)="showEventInfo(data, i); _expandZoneResponse()"
      >
        <div class="list-mail-history">
          <div class="list-mail-content">
            <span class="date">{{ getHeaderDate(data.evt) }}</span>
            <span class="name cng-ico_agent" *ngIf="!isIncommingMessage(data.evt)">{{ extractNameSender(data.evt) }}</span>
          </div>
          <div class="attachment cng-ico_attach" *ngIf="data.allAttachment.length > 0"></div>
        </div>
      </button>
    </li>
  </ul>
  <div title="{{ 'agent:contact.workspace.mail.history.display_next_mail' | translate }}">
    <button
      class="arrow right"
      [attr.aria-label]="'agent:contact.workspace.mail.history.display_next_mail' | translate"
      (click)="indicatorsSlider_next()"
      [disabled]="resultRight"
    >
      <span class="nodisplay">{{ 'agent:contact.workspace.mail.history.display_next_mail' | translate }}</span>
    </button>
  </div>
</div>
